import { marked } from 'marked'

/**
 * Wrap GFM tables for .msg-md-table-wrap styles; safe to import from multiple entry points (marked merges hooks).
 */
marked.use({
  hooks: {
    postprocess(html: string) {
      return html
        .replace(/<table\b[^>]*>/gi, (open) => `<div class="msg-md-table-wrap">${open}`)
        .replace(/<\/table>/gi, '</table></div>')
    },
  },
})
